import { FiatFormatter } from './fiatFormatter';
import { GasFormatter } from './gasFormatter';
import {
  percentageFormatter as iPercentageFormatter,
  percentageFormatterNoSign as ipercentageFormatterNoSign,
} from './percentageFormatter';
import { ShortFormatter } from './shortFormatter';
import { TokenFormatter } from './tokenFormatter';

// formatters
const gasFormatter = new GasFormatter();
const usdFormatter = new FiatFormatter('USD');
const tokenFormatter = new TokenFormatter();
const shortFormatter = new ShortFormatter();
const percentageFormatter = iPercentageFormatter;
const percentageFormatterNoSign = ipercentageFormatterNoSign;

// Memoized formatter cache for multi-currency support
const formatterCache = new Map<string, FiatFormatter>();
formatterCache.set('USD', usdFormatter);

export const getFiatFormatter = (currency: string): FiatFormatter => {
  const cached = formatterCache.get(currency);
  if (cached) return cached;
  const formatter = new FiatFormatter(currency);
  formatterCache.set(currency, formatter);
  return formatter;
};

// exports
export {
  gasFormatter,
  usdFormatter,
  tokenFormatter,
  shortFormatter,
  percentageFormatter,
  percentageFormatterNoSign,
};
